<script setup>
  import { Dialog, DialogDescription, DialogPanel, DialogTitle } from '@headlessui/vue'
  import { notify } from 'notiwind'
  import { Form } from 'vee-validate'
  import * as yup from 'yup'
  import { handleError } from '~/utils/error'

  const props = defineProps({
    filters: Object,
    name: String,
    open: { default: false, type: Boolean }
  })
  const emit = defineEmits()

  const { create } = useStrapi4()

  const schema = yup.object({
    name: props.name ? undefined : yup.string().required('${label} requis').label('Nom'),
    frequency: yup.string().required('${label} requise').oneOf(['daily', 'weekly', 'monthly'], '${label} invalide').label('Fréquence')
  })

  const submitting = ref(false)

  async function onSubmit(values, actions) {
    if (submitting.value) return
    submitting.value = true
    try {
      const f = props.filters
      const criteria = {}
      if (f.employerType?.length) criteria.employer = f.employerType.map(({ slug }) => slug)
      if (f.management) criteria.management = true
      if (f.region) criteria.region = [f.region.slug]
      if (f.search?.length) criteria.search = f.search
      if (f.sector?.length) criteria.sector = f.sector.map(({ slug }) => slug)
      if (f.teleworkable) criteria.teleworkable = true
      if (f.type) criteria.type = 'internship'
      await create('job-alerts', {
        criteria,
        frequency: values.frequency,
        name: props.name ?? values.name
      })
      actions.resetForm()
      notify({ group: 'main', type: 'success', title: 'Alerte créée' })
      emit('close')
    } catch (error) {
      handleError(error, true)
    }
    submitting.value = false
  }
</script>

<template>
  <Dialog
    class="fixed inset-0 z-20 flex h-full w-full justify-center overflow-auto bg-black bg-opacity-50 p-4 py-24 font-main text-tarawera-900 backdrop-blur"
    :open="open"
  >
    <DialogPanel class="my-auto max-w-screen-md rounded-xl bg-white p-4 shadow">
      <DialogTitle class="text-center font-special text-3xl font-bold">Création d’une alerte</DialogTitle>
      <DialogDescription class="mt-4">
        <slot>Une alerte vous permet de recevoir par email et à une fréquence choisie des offres qui correspondent aux critères sélectionnés.</slot>
      </DialogDescription>
      <Form class="mt-4" v-slot="{ errors }" :validationSchema="schema" @submit="onSubmit">
        <div class="-m-2 flex flex-wrap">
          <FormField class="basis-full p-2 sm:basis-1/2" id="name" v-if="!name" :error="errors.name" label="Nom" name="name" required />
          <FormField
            class="basis-full p-2 sm:basis-1/2"
            id="frequency"
            :error="errors.frequency"
            label="Fréquence"
            name="frequency"
            required
            type="select"
          >
            <option value="daily">Quotidienne</option>
            <option value="weekly">Hebdomadaire</option>
            <option value="monthly">Mensuelle</option>
          </FormField>
        </div>
        <div class="mt-4 space-x-2 text-center">
          <Button :disabled="submitting" type="submit">Créer</Button>
          <Button color="secondary" outline @click="$emit('close')">Annuler</Button>
        </div>
      </Form>
    </DialogPanel>
  </Dialog>
</template>
